import * as React from 'react';

import './WaitlistForm.css';
import { apiRequest } from '../api/client';

const WaitlistForm: React.FC = () => {
  const [email, setEmail] = React.useState('');
  const [submitted, setSubmitted] = React.useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const resp = await apiRequest('/waitlist', {
      method: 'POST',
      body: JSON.stringify({email: email})
    })
    setSubmitted(true);
  };

  return (
    <div className="waitlist-container">
      {submitted ? (
        <p className="success-message">Thanks! You’re on the list. 🎉</p>
      ) : (
        <form onSubmit={handleSubmit} className="waitlist-form">
          <input
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit">Join Waitlist Now</button>
        </form>
      )}
    </div>
  );
};

export default WaitlistForm;
